import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const ButtonOutlined = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'transparent',
    border: `1px solid var(--color-secondary)`,
    outline: 0,
    width: '100%',
    borderRadius: '5px',
    fontFamily: 'var(--font-family)',
    fontSize: '14px',
    color: 'var(--color-secondary-lighter)',
    height: '40px',
    cursor: 'pointer',
    fontWeight: 600,
    transition: 'var(--transition)',
    '&:hover': {
      transition: 'var(--transition)',
      background: 'var(--color-secondary)',
      color: 'var(--color-white)',
    },
    '&:hover svg': {
      transition: 'var(--transition)',
      color: 'white',
    },
    '&:focus': {
      transition: 'var(--transition)',
      background: 'var(--color-secondary)',
      color: 'white',
    },
    '&:focus svg': {
      transition: 'var(--transition)',
      color: 'white',
    },
    '&:disabled': {
      color: 'var(--disabled)',
      border: '1px solid var(--disabled)',
      cursor: 'not-allowed',
    },
  },
})(Button);

export default ButtonOutlined;
